// JSON verisinin JS modulu halidir (webpack + node ESM uyumlu)
const districtProfiles = [
  {
    "slug": "adalar",
    "name": "Adalar",
    "region": "Adalar",
    "priority": 3,
    "neighborhoods": [
      "Burgazada",
      "Büyükada",
      "Heybeliada",
      "Kınalıada",
      "Sedefadası"
    ],
    "nearby": [
      "kadikoy",
      "kartal",
      "maltepe"
    ],
    "localContext": "Adalar'da kepenk ihtiyaçı sahil dükkânları, butik oteller, marketler ve sezonluk işletmeler etrafında yoğunlaşır. Tuzlu hava, nem ve sezon başlangıcındaki uzun kapalı kalma süreleri kepenk mekanizmasını diğer ilçelere göre daha çabuk zorlayabilir.",
    "businessProfile": "Vapur iskeleleri çevresindeki kafe, restoran, tekne malzemesi satıcıları ve ada içi perakende işletmeleri için kepengin sessiz çalışması ve güvenli kilitlenmesi önceliklidir.",
    "accessNote": "Ada servislerinde ekip planlaması vapur saatleri, malzeme taşınması ve arızanın aciliyetine göre yapılır; bu nedenle ilk görüşmede kepenk ölçüsü, motor tipi ve arıza belirtisi netleştirilir.",
    "serviceNeed": "Adalar'da periyodik bakımda ray temizliği, pas kontrolü, motor zorlanma testi ve kumanda çekim mesafesi birlikte ele alınmalıdır.",
    "repairNeed": "En sık görülen sorunlar nem kaynaklı alıcı kart problemleri, oksitlenen bağlantı noktalar, sıkışan raylar ve uzun süre kullanılmayan motorlarda kalkış zorlanmasıdır.",
    "cta": "Adalar'da kepenk arızası yaşıyorsanız motor tipi ve bulunduğunuz ada bilgisini paylaşarak hızlı servis planlaması alabilirsiniz.",
    "faults": [
      "tuzlu hava nedeniyle ray sertleşmesi",
      "alıcı kart oksitlenmesi",
      "uzun kapalı kalma sonrası motor zorlanması",
      "kumanda çekim mesafesinin düşmesi"
    ]
  },
  {
    "slug": "arnavutkoy",
    "name": "Arnavutköy",
    "region": "Avrupa Yakası",
    "priority": 2,
    "neighborhoods": [
      "Bolluca",
      "Hadımköy",
      "Haraççı",
      "İmrahor",
      "Ömerli",
      "Taşluk",
      "Yavuz Selim"
    ],
    "nearby": [
      "basaksehir",
      "buyukcekmece",
      "catalca"
    ],
    "localContext": "Arnavutköy geniş sanayi alanları, lojistik akslari, yeni yerleşim bölgeleri ve cadde üstü dükkânlarıyla çok farklı kepenk kullanım şekillerine sahiptir. Depo girişlerinde ağır kepenkler, mahalle merkezlerinde ise daha sık açılıp kapanan otomatik sistemler öne çıkar.",
    "businessProfile": "Hadımköy ve Bolluca tarafında depo kepenkleri, Taşoluk ve merkez bölgelerde market, fırın, eczane ve servis dükkânları için hızlı müdahale ihtiyaçı yüksektir.",
    "accessNote": "İlçe geniş olduğu için ekip yönlendirmesinde mahalle, ana yol bağlantısı ve kepengin işletme içindeki konumu önemlidir.",
    "serviceNeed": "Arnavutköy'de kepenk bakımı yapılırken ağır kanatlarda motor torku, sanayi tipi sistemlerde zincir ve rulman kontrolleri ayrıca değerlendirilir.",
    "repairNeed": "Sık görülen arızalar santral motor zorlanması, zincir gevşemesi, raydan çıkma, elektrik hattındaki voltaj dalgalanmaları ve kumanda alıcı sorunlarıdır.",
    "cta": "Arnavutköy'de kepenk servisi için mahalle ve kepenk türünü ileterek servis talebi oluşturabilirsiniz.",
    "faults": [
      "santral motor tork kaybı",
      "zincir gevşemesi",
      "raydan çıkma",
      "voltaj dalgalanması"
    ]
  },
  {
    "slug": "atasehir",
    "name": "Ataşehir",
    "region": "Anadolu Yakası",
    "priority": 3,
    "neighborhoods": [
      "Atatürk",
      "Barbaros",
      "Ferhatpaşa",
      "İçerenköy",
      "İnönü",
      "Kayışdağı",
      "Küçükbakkalköy",
      "Yeni Çamlıca"
    ],
    "nearby": [
      "kadikoy",
      "umraniye",
      "uskudar"
    ],
    "localContext": "Ataşehir'de plaza altları, site dükkânları, ofis girişleri ve cadde mağazaları kepenk sistemlerini yoğun kullanır. İşletmelerde görüntü, sessiz çalışma ve arıza sonrası hızlı tekrar kullanıma alma önemlidir.",
    "businessProfile": "Barbaros ve Atatürk mahallelerinde kurumsal işletmeler, İçerenköy ve Küçükbakkalköy tarafında cadde esnafı ve depo girişleri öne çıkar.",
    "accessNote": "Site ve plaza girişlerinde güvenlik prosedürü, otopark erişimi ve servis saatleri önceden planlanır.",
    "serviceNeed": "Ataşehir kepenk servisinde kumanda eşleştirme, fotosel kontrolü, motor ses testi ve ray ayarı birlikte yapıldığında tekrar arıza riski azalır.",
    "repairNeed": "En sık talepler alıcı kart değişimi, kumanda tanıtma, motor fren problemi, fotosel arızası ve sessiz çalışmayan kepenklerdir.",
    "cta": "Ataşehir'de kepenk tamiri veya bakımı için lokasyon giriş koşullarını ve arıza belirtisini paylaşabilirsiniz.",
    "faults": [
      "fotosel arızası",
      "kumanda tanıtma sorunu",
      "motor fren sesi",
      "ray ayarı bozulması"
    ]
  },
  {
    "slug": "avcilar",
    "name": "Avcılar",
    "region": "Avrupa Yakası",
    "priority": 3,
    "neighborhoods": [
      "Ambarlı",
      "Cihangir",
      "Denizköşler",
      "Firuzköy",
      "Gümüspala",
      "Merkez",
      "Tahtakale",
      "Üniversite"
    ],
    "nearby": [
      "beylikduzu",
      "kucukcekmece",
      "esenyurt"
    ],
    "localContext": "Avcılar sahil hattından sanayi bölgelerine kadar değişen işletme yoğunluğuna sahiptir. Nemli hava, yoğun cadde trafiği ve sık açılıp kapanan kepenkler bakım ihtiyaçını artırır.",
    "businessProfile": "Merkez ve Denizköşler'de cadde dükkânları, Ambarlı ve Firuzköy tarafında depo ve üretim alanları için kepenk güvenliği öne çıkar.",
    "accessNote": "E-5 ve sahil akslarindaki trafik saatleri servis planlamasında dikkate alınır.",
    "serviceNeed": "Avcılar'da kepenk bakımı ray temizliği, motor kalkış testi, kumanda alıcı kontrolü ve mekanik gevşeme denetimiyle yapılmalıdır.",
    "repairNeed": "Sık arızalar ray şişme, kumanda çekmemesi, motorun kepengi yarıda bırakması ve kepenk kilit sisteminin sertleşmesi.",
    "cta": "Avcılar kepenk servisi için mahalle, kepenk ölçüsü ve motor belirtisini iletin; çözüm planını hızlı netleştirelim.",
    "faults": [
      "ray şişme",
      "kumanda çekmemesi",
      "motorun yarıda durması",
      "kilit sertleşmesi"
    ]
  },
  {
    "slug": "bagcilar",
    "name": "Bağcılar",
    "region": "Avrupa Yakası",
    "priority": 1,
    "neighborhoods": [
      "Bağlar",
      "Demirkapı",
      "Fatih",
      "Güneşli",
      "Kirazlı",
      "Mahmutbey",
      "Yavuzselim",
      "Yenigün"
    ],
    "nearby": [
      "gungoren",
      "bahcelievler",
      "basaksehir"
    ],
    "localContext": "Bağcılar'da kepenk talepleri Güneşli, Mahmutbey, Kirazlı ve Bağlar gibi ticaretin yoğun olduğu noktalarda artar. İlçede mağazalar, atölyeler, depo girişleri ve ara sokak dükkânları farklı kepenk tipleri kullanır.",
    "businessProfile": "Tekstil, yedek parça, gıda, kargo ve cadde perakendesi Bağcılar'da kepenk sistemlerini gün içinde sık kullanır.",
    "accessNote": "Mahmutbey ve Güneşli tarafında yoğun trafik saatleri, servis ekibinin doğru parça ve net adresle çıkmasını daha da önemli hale getirir.",
    "serviceNeed": "Bağcılar kepenk servisinde motor tork kontrolü, kepenk ray hizası, kumanda alıcı hassasiyeti ve güvenli kapanma testi birlikte yapılmalıdır.",
    "repairNeed": "İlçede en sık karşılaşılan sorunlar motorun zor kalkması, kepengin raydan çıkması, alıcı kart arızası, kumanda kaybı ve mekanik parça aşınmasıdır.",
    "cta": "Bağcılar'da kepenk tamiri için arıza fotoğrafı ve mahalle bilgisini göndererek servis isteyebilirsiniz.",
    "faults": [
      "motorun zor kalkması",
      "raydan çıkma",
      "alıcı kart arızası",
      "kumanda kaybı"
    ]
  },
  {
    "slug": "bahcelievler",
    "name": "Bahçelievler",
    "region": "Avrupa Yakası",
    "priority": 2,
    "neighborhoods": [
      "Bahçelievler Merkez",
      "Kocasinan",
      "Şirinevler",
      "Soğanlı",
      "Yenibosna"
    ],
    "nearby": [
      "bakirkoy",
      "gungoren",
      "bagcilar"
    ],
    "localContext": "Bahçelievler'de cadde mağazaları, apartman altı dükkânları, sağlık kuruluşları ve Yenibosna hattındaki ticari alanlar kepenk servis talebini belirler.",
    "businessProfile": "Şirinevler ve Yenibosna'da yoğun yaya trafiği olan dükkânlar, Kocasinan ve Soğanlı'da mahalle esnafı kepenk güvenliğine önem verir.",
    "accessNote": "E-5 bağlantısı nedeniyle servis saatleri ve park imkânı önceden değerlendirilir.",
    "serviceNeed": "Bahçelievler kepenk servisinde sık kullanımdan kaynaklı ray aşınması, yay dengesi ve motor fren ayarı özellikle kontrol edilir.",
    "repairNeed": "Sık görülen arızalar kumanda geç algılama, kepengin sert kapanması, motor sesi, yay gevşemesi ve elektrik kesintisi sonrası manuel kullanım problemidir.",
    "cta": "Bahçelievler'de kepenk servisi için dükkân tipi ve arıza saatini bildirerek servis kaydı açabilirsiniz.",
    "faults": [
      "kumanda geç algılama",
      "sert kapanma",
      "motor sesi",
      "yay gevşemesi"
    ]
  },
  {
    "slug": "bakirkoy",
    "name": "Bakırköy",
    "region": "Avrupa Yakası",
    "priority": 2,
    "neighborhoods": [
      "Ataköy",
      "Cevizlik",
      "Florya",
      "Kartaltepe",
      "Osmaniye",
      "Yeşilköy",
      "Zeytinlik"
    ],
    "nearby": [
      "bahcelievler",
      "zeytinburnu",
      "kucukcekmece"
    ],
    "localContext": "Bakırköy'de AVM çevreleri, sahil işletmeleri, klinikler, pasaj dükkânları ve cadde mağazaları kepenk sistemlerini hem güvenlik hem vitrin düzeni için kullanır.",
    "businessProfile": "Ataköy ve Florya'da modern mağazalar, Cevizlik ve Osmaniye'de cadde esnafı, Yeşilköy'de sahil işletmeleri farklı servis beklentilerine sahiptir.",
    "accessNote": "Pasaj ve AVM çevresinde servis için yükleme noktası, çalışma saati ve güvenlik girişi önceden konuşulur.",
    "serviceNeed": "Bakırköy kepenk bakımında sessiz çalışma, fotosel güvenliği, kumanda çekim mesafesi ve vitrin kepenklerinin düz kapanması önceliklidir.",
    "repairNeed": "Sık arızalar motor sesi, fotosel hatası, ray hizasızlığı, kumanda kaydı silinmesi ve manuel zincir sorunlarıdır.",
    "cta": "Bakırköy'de kepenk tamiri için mekân tipi ve çalışma saatinizi paylaşarak uygun servis aralığı alabilirsiniz.",
    "faults": [
      "fotosel hatası",
      "ray hizasızlığı",
      "manuel zincir sorunu",
      "motor sesi"
    ]
  },
  {
    "slug": "basaksehir",
    "name": "Başakşehir",
    "region": "Avrupa Yakası",
    "priority": 1,
    "neighborhoods": [
      "Bahçeşehir",
      "Başak",
      "Başakşehir Merkez",
      "İkitelli",
      "Kayabaşı",
      "Sahintepe"
    ],
    "nearby": [
      "arnavutkoy",
      "bagcilar",
      "kucukcekmece"
    ],
    "localContext": "Başakşehir'de konut altlarındaki dükkânlar, İkitelli sanayi bölgesi, depo girişleri ve yeni ticari akslar kepenk servis ihtiyaçını çeşitlendirir.",
    "businessProfile": "İkitelli'de ağır sanayi kepenkleri, Bahçeşehir ve Kayabaşı'nda site mağazaları, Başakşehir merkezde cadde işletmeleri yoğunluk oluşturur.",
    "accessNote": "Sanayi ve site bölgelerinde kepenge ulaşım, araç girişi ve ekipman taşıma koşulları servis planında dikkate alınır.",
    "serviceNeed": "Başakşehir kepenk servisinde sanayi tipi motor kontrolü, zincir sistemleri, alıcı kart programlama ve güvenli kapanma testleri birlikte yapılır.",
    "repairNeed": "Sık arızalar ağır kepenk motor zorlanması, zincir boşluğu, fotosel kesintisi, ray yamulması ve kumanda frekans karışıklığıdır.",
    "cta": "Başakşehir'de kepenk servisi için kepengin sanayi tipi mi mağaza tipi mi olduğunu belirterek hızlı yönlendirme alabilirsiniz.",
    "faults": [
      "ağır kepenk motor zorlanması",
      "zincir boşluğu",
      "fotosel kesintisi",
      "ray yamulması"
    ]
  },
  {
    "slug": "bayrampasa",
    "name": "Bayrampaşa",
    "region": "Avrupa Yakası",
    "priority": 1,
    "neighborhoods": [
      "Altintepsi",
      "Cevatpaşa",
      "Kartaltepe",
      "Kocatepe",
      "Muratpaşa",
      "Orta",
      "Terazidere",
      "Yıldırım"
    ],
    "nearby": [
      "esenler",
      "gaziosmanpasa",
      "zeytinburnu"
    ],
    "localContext": "Bayrampaşa'da sanayi siteleri, hal ve lojistik hareketi, cadde dükkânları ve AVM çevresi kepenk kullanımının yoğun olduğu alanlarıdır.",
    "businessProfile": "Terazidere ve Kocatepe tarafında atölyeler, Kocatepe Forum çevresinde mağazalar, Yıldırım ve Muratpaşa'da mahalle esnafı öne çıkar.",
    "accessNote": "Yoğun yükleme boşaltma alanlarında kepenk arızası is akışını durdurduğu için servis saati ve malzeme hazırlığı kritik olur.",
    "serviceNeed": "Bayrampaşa kepenk servisinde mekanik yıpranma, santral motor performansı, ray sabitlemeleri ve kilit güvenliği birlikte denetlenir.",
    "repairNeed": "Sık arızalar raydan çıkma, kepenk sacında eğilme, motorun sigorta aştırarak durması ve kumanda alıcı kart sorunlarıdır.",
    "cta": "Bayrampaşa kepenk tamiri için arızanın acil olup olmadığını ve dükkânın bulunduğu mahalleyi paylaşın.",
    "faults": [
      "raydan çıkma",
      "kepenk saçı eğilmesi",
      "sigorta aştırma",
      "alıcı kart sorunu"
    ]
  },
  {
    "slug": "besiktas",
    "name": "Beşiktaş",
    "region": "Avrupa Yakası",
    "priority": 2,
    "neighborhoods": [
      "Akat",
      "Arnavutköy",
      "Bebek",
      "Etiler",
      "Levent",
      "Ortaköy",
      "Sinanpaşa",
      "Ulus"
    ],
    "nearby": [
      "beyoglu",
      "sariyer",
      "sisli"
    ],
    "localContext": "Beşiktaş'ta restoranlar, butik mağazalar, sahil işletmeleri, ofis girişleri ve yüksek profil cadde dükkânları kepenk sistemlerini estetik ve güvenlik için kullanır.",
    "businessProfile": "Etiler ve Levent'te kurumsal alanlar, Ortaköy ve Bebek'te restoran-kafe işletmeleri, Sinanpaşa'da yoğun cadde esnafı öne çıkar.",
    "accessNote": "Dar sokaklar, vale alanları ve işletme açılış saatleri nedeniyle servis planında saat seçimi önemlidir.",
    "serviceNeed": "Beşiktaş kepenk servisinde sessiz çalışma, vitrin kepengi hizası, motor fren sesi ve fotosel güvenliği özellikle kontrol edilir.",
    "repairNeed": "Sık arızalar motor sesi, kumanda geç algılama, kepengin vitrine sürtmesi, fotosel arızası ve manuel kullanım zorluğudur.",
    "cta": "Beşiktaş'ta kepenk servisi için işletme açılış saatinizi ve sokak erişim bilgisini iletebilirsiniz.",
    "faults": [
      "vitrine sürtme",
      "motor fren sesi",
      "fotosel arızası",
      "manuel kullanım zorluğu"
    ],
    "customContent": {
      "summary": "Beşiktaş'ta kepenk servisi ve tamiri: çarşı esnafından Levent–Etiler plaza girişlerine, Ortaköy–Bebek sahil işletmelerine kadar mahalle bazlı planlama. Maç günlerindeki erişim koşullarına göre kapatma ve güvenlik çözümleri.",
      "description": "Beşiktaş kepenk servisi ve tamiri: Çarşı, Sinanpaşa, Ortaköy, Bebek ve Levent bölgelerinde motor, ray, kumanda ve bakım desteği.",
      "answerBlock": {
        "title": "Beşiktaş kepenk servisi ve tamiri – kısaca",
        "summary": "Beşiktaş'ta iki ayrı ihtiyaç profili var: çarşı ve Sinanpaşa'daki yoğun esnaf dükkânlarında arıza giderme; Levent–Etiler plaza girişleri ile Ortaköy–Bebek sahil işletmelerinde ise estetik, sessizlik ve toplu bakım planlaması öne çıkar. Stadyum çevresinde maç günündeki erişim ve güvenlik koşulları ayrıca değerlendirilir.",
        "facts": [
          {
            "label": "Kapsam",
            "text": "Kepenk tamiri, bakım, motor ve ray onarımı, kumanda tanıtma, fotosel, eski kepenklerin motorluya çevrilmesi ve sıfır montaj."
          },
          {
            "label": "Müdahale alanı",
            "text": "Beşiktaş çarşı, Sinanpaşa, Ortaköy, Arnavutköy, Bebek, Etiler, Levent, Akatlar ve Ulus hattı."
          },
          {
            "label": "Beşiktaş'a özgü durumlar",
            "text": "Maç günü yoğunluğunda hızlı kapatma; sahil hattında tuzlu hava kaynaklı pas; dar çarşı sokaklarında araç erişim planı."
          },
          {
            "label": "Servis planlama",
            "text": "Randevu saati; işletmenin çalışma düzeni, ekip müsaitliği, trafik ve sokak erişimine göre paylaşılır."
          }
        ]
      },
      "sections": [
        {
          "title": "Çarşıdan plazaya: Beşiktaş'ın iki kepenk ihtiyacı",
          "paragraphs": [
            "Beşiktaş çarşısı ve Sinanpaşa çevresi, İstanbul'un en yoğun mahalle ticaret bölgelerinden biridir. Dar sokaklarda yan yana sıralanan esnaf dükkânlarında kepenkler küçük ve orta ölçülüdür, açılış-kapanış rutini her gün işler. Sabah açılışında oluşan arızalar işletmenin erişimini doğrudan etkilediği için talepte kepengin açık-kapalı durumu belirtilmelidir.",
            "Levent, Etiler ve Ulus hattında profil değişir: plaza girişleri, zincir mağazalar ve çok katlı rezidans giriş kepenkleri. Burada ölçüler büyür, kullanım kurumsallaşır ve bakım takvimi site yönetimiyle yürütülür. Çok girişli binalarda ortak envanter ve bakım planı seçenekleri değerlendirilebilir."
          ]
        },
        {
          "title": "Maç günleri: stadyum çevresinde kepenk güvenliği",
          "paragraphs": [
            "Stadyum çevresindeki cadde esnafı için maç günleri özel bir planlama gerektirir. Maç öncesi ve sonrası oluşan kalabalıkta bazı işletmeler kepengi erken kapatmak ister; bu durumda hızlı kapanma ve sağlam kilit devreye girer. Maç günlerinde kepengin yarıda kalması ya da kumandanın çalışmaması istenmeyen bir güvenlik açığıdır.",
            "Maç günü öncesinde limit, fren, kumanda ve kilit kontrolü yapılması; gerekirse yay kilidi veya manyetik kontak seçeneğinin değerlendirilmesi riski azaltır. Randevu saati, bölgedeki yol kapanışları ve işletmenin erişim koşulları dikkate alınarak netleştirilir."
          ]
        },
        {
          "title": "Ortaköy–Bebek hattında deniz havası ve malzeme seçimi",
          "paragraphs": [
            "Ortaköy, Arnavutköy ve Bebek sahili, Boğaz'ın nemli ve tuzlu havasına açık bir cepheedir. Sahildeki kafe ve restoranların kepenklerinde ray ve zincirde paslanma, sac profilde yüzey bozulması sık görülür. Turist yoğunluğu nedeniyle burada görünüm de kritiktir: paslı bir kepenk, işletmenin algısını doğrudan etkiler.",
            "Sahil işletmelerinde alüminyum veya kaliteli galvanizli profil değerlendirilebilir. Pas kontrolü ve bakım aralığı; cephe yönü, kullanım sıklığı, üretici talimatı ve mevcut korozyon durumuna göre belirlenmelidir."
          ]
        },
        {
          "title": "Beşiktaş'ta öne çıkan arıza koşulları",
          "paragraphs": [
            "Bölgenin işletme ve erişim yapısında karşılaşılabilecek sorunlar şunlardır:"
          ],
          "highlights": [
            "Çarşı sokaklarında araç ve vale trafiğinin neden olduğu perde ezikleri ve raydan çıkma",
            "Eski tip çarşı kepenklerinde yay kilidi aşınması ve manuel açma zorluğu",
            "Sahil hattında nem kaynaklı pas ve alıcı kart temas sorunları",
            "Plaza girişlerinde yoğun çevrim nedeniyle motor fren sesi ve limit kayması",
            "Vitrin cephelerinde fotosel hizasının bozulması ve kepenğin tam kapanmaması"
          ]
        },
        {
          "title": "Eski çarşı kepenklerim otomatik olabilir mi?",
          "paragraphs": [
            "Elle kapanan eski bir kepenkte perde ve raylar sağlamsa motor, kontrol kartı ve kumanda eklenmesi mümkün olabilir; perde yıpranmışsa ölçüye özel yeni sistem daha ekonomik olabilir. Karar, yerinde ölçüm ve mekanik kontrolden sonra verilmelidir.",
            "Dönüşüm sırasında elektrik kesintisinde erişim ihtiyacı da değerlendirilerek motor tipine uygun manuel açma seçeneği projeye eklenmelidir."
          ]
        },
        {
          "title": "Beşiktaş kepenk fiyatları",
          "paragraphs": [
            "Tamir ücreti arıza türüne ve parçaya göre; sıfır kepenk m², malzeme ve motor gücüne göre fiyatlanır. Çarşı ölçülerindeki standart dükkân kepenkleri ile plaza girişlerinin geniş kepenkleri arasında fiyat farkı doğaldır. Yerinde kontrolün kapsamı ön görüşmede açıklanır; onay alınmadan işlem yapılmaz."
          ],
          "links": [
            {
              "title": "Kepenk Fiyatları 2026 – Güncel Tablo",
              "path": "/kepenk-fiyatlari"
            },
            {
              "title": "Sıfır Kepenk Montajı",
              "path": "/sifir-kepenk"
            }
          ]
        },
        {
          "title": "Dar sokaklarda servis planlaması",
          "paragraphs": [
            "Beşiktaş çarşısında araç erişimi kısıtlıdır; servis aracının sokak girişinde bekleyeceği noktayı ve dükkânın cephe yönünü telefonla netleştiriyoruz. Plaza ve rezidans girişlerinde ise bina yönetiminin servis saat prosedürü olabilir; site yönetimiyle koordine edilmiş randevu planlanır.",
            "Kepenk açık kaldıysa bu bilgi talep sırasında belirtilmelidir. Uygun yönlendirme süresi ekip müsaitliği, trafik ve gerekli parça olasılığına göre paylaşılır."
          ],
          "links": [
            {
              "title": "Beyoğlu Kepenk Servisi",
              "path": "/beyoglu"
            },
            {
              "title": "Sarıyer Kepenk Servisi",
              "path": "/sariyer"
            },
            {
              "title": "Şişli Kepenk Servisi",
              "path": "/sisli"
            },
            {
              "title": "Kepenk Motor Seçim Rehberi",
              "path": "/bilgi-merkezi/rehber/kepenk-motor-secim-rehberi"
            }
          ]
        }
      ],
      "faqs": [
        {
          "question": "Beşiktaş çarşısında tamir süreci nasıl planlanır?",
          "answer": "Çarşı ve Sinanpaşa çevresindeki taleplerde sokak erişimi, kepengin açık-kapalı durumu ve arıza belirtisi alınır. Yönlendirme süresi ekip müsaitliği ve trafiğe göre; gerekli parça ise yerinde tespitten sonra paylaşılır."
        },
        {
          "question": "Maç günü öncesi kepengin güvenli kapanması için ne yapabilirsiniz?",
          "answer": "Fren, limit, kumanda ve kilit mekanizması maç günü öncesinde kontrol edilebilir; ihtiyaca göre yay kilidi veya alarm kontağı seçeneği değerlendirilir. Servis saati bölgedeki erişim koşullarına göre netleştirilir."
        },
        {
          "question": "Bebek'teki restoranımın kepengi gece bozuldu, ne kadar hızlı gelirsiniz?",
          "answer": "Kepengin açık veya kapalı kaldığını ve işletmenin kapanış saatini iletin. Uygun yönlendirme zamanı ekip müsaitliği ve trafik durumuna göre telefonla paylaşılır; sabit varış süresi taahhüt edilmez."
        },
        {
          "question": "Levent'teki plaza girişimizin 4 kepengi var; tek sözleşmeyle bakım alabilir miyiz?",
          "answer": "Evet. Çok girişli binalar için tüm kepenkleri kapsayan yıllık bakım anlaşması düzenliyoruz. Tek çağrıyla tüm girişlerin kontrolü planlanır; site yönetimiyle servis saat prosedürü koordine edilir."
        },
        {
          "question": "Ortaköy'de paslanan sac kepenk mi tamir edilmeli, yenilenmeli mi?",
          "answer": "Yüzey korozyonu sınırlıysa perde onarılıp boyanabilir; profil içi korozyon ve ray aşınması varsa yenileme daha ekonomik olabilir. Malzeme seçimi cephe yönü, kaplama kalitesi ve kullanım koşullarıyla birlikte yapılmalıdır."
        },
        {
          "question": "Eski el kepenklerimi otomatiğe çevirebilir misiniz?",
          "answer": "Evet, perde sağlamsa motor, kontrol kartı ve kumanda eklenerek otomatiğe çevriliyor. Elektrik kesintisi için manuel acil açma sistemi de kuruluyor. Ölçüm sonrası çevirme ve yenileme maliyetlerini karşılaştırıp sunuyoruz."
        },
        {
          "question": "Vale araçları kepenk perdesini ezip raydan çıkardı, tamir edilir mi?",
          "answer": "Ezik perde genellikle düzeltilerek onarılır; raydan çıkmışsa ray ve rulman kontrolü yapılır, hasar sınırlıysa yerinde tamamlanabilir. Perde profil değişimi gerekiyorsa ölçü alınıp fiyat bildirilir."
        },
        {
          "question": "Ulus ve Akatlar tarafında site dükkânları için toplu bakım veriyor musunuz?",
          "answer": "Evet. Ulus, Akatlar ve Etiler hattındaki site dükkânları ve rezidans girişleri için toplu bakım planları hazırlıyoruz; tek randevuda birden çok kepengin kontrolü yapılır."
        }
      ]
    }
  },
  {
    "slug": "beykoz",
    "name": "Beykoz",
    "region": "Anadolu Yakası",
    "priority": 3,
    "neighborhoods": [
      "Anadolu Kavağı",
      "Beykoz Merkez",
      "Çavuşbaşı",
      "Kanlıca",
      "Polonezköy",
      "Riva"
    ],
    "nearby": [
      "cekmekoy",
      "sariyer",
      "uskudar"
    ],
    "localContext": "Beykoz'da sahil işletmeleri, villa garajları, mahalle dükkânları ve depo alanları kepenk ihtiyaçını farklı şekillerde ortaya çıkarır.",
    "businessProfile": "Merkez ve Kanlıca'da cadde dükkânları, Riva ve Polonezköy hattında sezonluk işletmeler, Çavuşbaşı'nda depo ve atölye kullanımı görülür.",
    "accessNote": "İlçe geniş ve bölgeler arası mesafe fazla olduğu için ekip yönlendirmesinde mahalle bilgisi belirleyicidir.",
    "serviceNeed": "Beykoz kepenk servisinde nem etkisi, motor gücü, garaj kepenklerinde güvenli kapanma ve kumanda menzili birlikte kontrol edilir.",
    "repairNeed": "Sık arızalar ray sertleşmesi, motorun ağır kalkması, kumanda çekim sorunu ve garaj kepenklerinde limit ayarı bozulmasıdır.",
    "cta": "Beykoz kepenk tamiri için mahalle ve kepengin dükkân mi garaj mi olduğunu paylaşarak servis isteyin.",
    "faults": [
      "ray sertleşmesi",
      "ağır kalkış",
      "kumanda menzil sorunu",
      "limit ayarı bozulması"
    ]
  },
  {
    "slug": "beylikduzu",
    "name": "Beylikdüzü",
    "region": "Avrupa Yakası",
    "priority": 3,
    "neighborhoods": [
      "Adnan Kahveci",
      "Barış",
      "Büyükşehir",
      "Gürpınar",
      "Kavaklı",
      "Marmara",
      "Yakuplu"
    ],
    "nearby": [
      "avcilar",
      "buyukcekmece",
      "esenyurt"
    ],
    "localContext": "Beylikdüzü'nde site altı dükkânlar, sanayi alanları, AVM çevreleri ve yeni ticari merkezler modern kepenk sistemlerini yoğun kullanır.",
    "businessProfile": "Adnan Kahveci ve Marmara mahallelerinde mağazalar, Yakuplu ve Kavaklı'da depo girişleri, Gürpınar'da sahil işletmeleri öne çıkar.",
    "accessNote": "Site girişleri ve kapalı otoparklar için servis araçının erişim bilgisi önceden alınmalıdır.",
    "serviceNeed": "Beylikdüzü kepenk servisinde modern motor sistemleri, kumanda tanıtma, fotosel kontrolü ve periyodik ray temizliği birlikte yapılır.",
    "repairNeed": "Sık arızalar limit ayarı kayması, kumanda kodu silinmesi, fotosel görüşünün kapanması ve kepengin bir tarafa yatmasıdır.",
    "cta": "Beylikdüzü'nde kepenk servisi için site/dükkân giriş bilgisini ve arıza belirtisini iletin.",
    "faults": [
      "limit ayarı kayması",
      "kumanda kodu silinmesi",
      "fotosel görüşü kapanması",
      "kepengin yatması"
    ]
  },
  {
    "slug": "beyoglu",
    "name": "Beyoğlu",
    "region": "Avrupa Yakası",
    "priority": 3,
    "neighborhoods": [
      "Cihangir",
      "Galata",
      "Karaköy",
      "Kasımpaşa",
      "Şişhane",
      "Taksim"
    ],
    "nearby": [
      "besiktas",
      "fatih",
      "sisli"
    ],
    "localContext": "Beyoğlu'nda tarihi pasajlar, kafe ve restoranlar, turistik dükkânlar, gece açık işletmeler ve dar sokak mağazaları kepenk sistemlerini yoğun kullanır.",
    "businessProfile": "Karaköy ve Galata'da turistik işletmeler, Taksim ve Cihangir'de restoran-kafe yoğunluğu, Kasımpaşa'da mahalle esnafı öne çıkar.",
    "accessNote": "Dar sokaklar ve yükleme saatleri nedeniyle servis planında araç durma noktası önceden netleştirilir.",
    "serviceNeed": "Beyoğlu kepenk servisinde sessiz çalışma, vitrin görünümü, kilit güvenliği ve manuel açma sistemi ayrıca kontrol edilir.",
    "repairNeed": "Sık arızalar kepengin sıkışması, kilit mekanizması sertleşmesi, motor sesi, kumanda kaybı ve ray içine yabancı madde girmesidir.",
    "cta": "Beyoğlu kepenk tamiri için sokak erişimi ve kepengin açık mi kapalı mi kaldığını bildirerek servis isteyin.",
    "faults": [
      "kilit sertleşmesi",
      "ray içine yabancı madde",
      "motor sesi",
      "kepengin sıkışması"
    ]
  },
  {
    "slug": "buyukcekmece",
    "name": "Büyükçekmece",
    "region": "Avrupa Yakası",
    "priority": 3,
    "neighborhoods": [
      "Büyükçekmece Merkez",
      "Güzelyalı",
      "Kumburgaz",
      "Mimarsinan",
      "Muratçeşme"
    ],
    "nearby": [
      "beylikduzu",
      "catalca",
      "silivri"
    ],
    "localContext": "Büyükçekmece'de sahil işletmeleri, yazlik bölgeler, depo alanları ve cadde dükkânları kepenk sistemlerini sezonluk ve sürekli kullanım için tercih eder.",
    "businessProfile": "Kumburgaz ve Güzelyalı'da sezonluk işletmeler, Mimarsinan ve merkezde market, restoran ve atölyeler öne çıkar.",
    "accessNote": "Sahil ve TEM bağlantı akslari arasındaki mesafe servis saatini etkileyebileceği için mahalle bilgisi önemlidir.",
    "serviceNeed": "Büyükçekmece kepenk servisinde nem ve rüzgâr etkisi, ray sabitlemesi, motor gücü ve manuel açma sistemi birlikte değerlendirilir.",
    "repairNeed": "Sık arızalar paslanmaya bağlı ray sertleşmesi, motorun zorlanması, kepenk perdesinde eğilme ve kumanda alıcı arızasıdır.",
    "cta": "Büyükçekmece kepenk servisi için sezonluk açılış veya acil arıza durumunuzu belirtin.",
    "faults": [
      "pas kaynaklı ray sertleşmesi",
      "perde eğilmesi",
      "motor zorlanması",
      "alıcı arızası"
    ]
  },
  {
    "slug": "catalca",
    "name": "Çatalca",
    "region": "Avrupa Yakası",
    "priority": 2,
    "neighborhoods": [
      "Binkılıç",
      "Çatalca Merkez",
      "Gümüşpınar",
      "Karamandere",
      "Subaşı"
    ],
    "nearby": [
      "arnavutkoy",
      "buyukcekmece",
      "silivri"
    ],
    "localContext": "Çatalca'da depo, atölye, tarımsal işletme, sanayi kapısı ve merkez dükkânları için kepenk sistemleri dayanıklılık odaklı kullanılır.",
    "businessProfile": "Merkezde cadde esnafı, Gümüşpınar ve Karamandere hattında depo ve üretim alanları, Subaşı tarafında geniş girişli kepenkler öne çıkar.",
    "accessNote": "Kırsal ve geniş alanlı lokasyonlarda ekip doğru motor ve mekanik parça seçimiyle çıkmalıdır.",
    "serviceNeed": "Çatalca kepenk servisinde ağır kepenk motor gücü, zincir sistemi, ray sabitlemesi ve elektrik hattının yeterliliği birlikte kontrol edilir.",
    "repairNeed": "Sık arızalar santral motor yorgunluğu, zincir kopması, rayda darbe, kumanda alıcı menzil sorunu ve elektrik besleme problemidir.",
    "cta": "Çatalca'da kepenk tamiri için kepenk ölçüsünü ve lokasyon tipini paylaşarak servis planlaması isteyin.",
    "faults": [
      "santral motor yorgunluğu",
      "zincir kopması",
      "ray darbesi",
      "elektrik besleme problemi"
    ]
  },
  {
    "slug": "cekmekoy",
    "name": "Çekmeköy",
    "region": "Anadolu Yakası",
    "priority": 3,
    "neighborhoods": [
      "Alemdağ",
      "Hamidiye",
      "Madenler",
      "Merkez",
      "Ömerli",
      "Taşdelen"
    ],
    "nearby": [
      "beykoz",
      "sancaktepe",
      "umraniye"
    ],
    "localContext": "Çekmeköy'de yeni yerleşim alanları, site altı dükkânlar, garaj kepenkleri ve mahalle ticareti bir arada bulunur.",
    "businessProfile": "Taşdelen ve Madenler'de site dükkânları, Ömerli tarafında villa ve depo girişleri, merkezde perakende işletmeler öne çıkar.",
    "accessNote": "Site güvenlik girişi, kapalı otopark yüksekliği ve mahalle konumu servis planında dikkate alınır.",
    "serviceNeed": "Çekmeköy kepenk servisinde garaj kepenklerinde limit ayarı, mağaza kepenklerinde kumanda sistemi ve ray temizliği birlikte kontrol edilir.",
    "repairNeed": "Sık arızalar kumanda çekim zayıflığı, garaj kepenginin yarıda kalması, motor fren sesi ve ray içinde biriken tozdur.",
    "cta": "Çekmeköy kepenk servisi için site adı veya mahalle bilgisini ekleyerek hızlı kayıt açabilirsiniz.",
    "faults": [
      "garaj kepenginin yarıda kalması",
      "kumanda çekim zayıflığı",
      "motor fren sesi",
      "ray tozu"
    ]
  },
  {
    "slug": "esenler",
    "name": "Esenler",
    "region": "Avrupa Yakası",
    "priority": 1,
    "neighborhoods": [
      "Birlik",
      "Davutpaşa",
      "Menderes",
      "Nine Hatun",
      "Oruç Reis",
      "Turgut Reis"
    ],
    "nearby": [
      "bagcilar",
      "bayrampasa",
      "gungoren"
    ],
    "localContext": "Esenler'de yoğun mahalle esnafı, sanayiye yakın atölyeler, otogar çevresi ve cadde dükkânları kepenk sistemlerini her gün aktif kullanır.",
    "businessProfile": "Davutpaşa ve Oruç Reis tarafında atölye-depo kullanımı, Menderes ve Nine Hatun'da cadde perakendesi öne çıkar.",
    "accessNote": "Dar sokaklar ve yoğun park sorunu nedeniyle servis ekibi arıza bilgisini net alip doğru ekipmanla çıkmalıdır.",
    "serviceNeed": "Esenler kepenk servisinde ray hizası, motor gücü, kumanda sistemi, kilit akşam ve kepenk perdesi birlikte kontrol edilir.",
    "repairNeed": "Sık arızalar kepengin raydan çıkması, motorun sigorta aştırması, alıcı kartın çalışmaması ve mekanik darbe sonrası perde eğilmesi.",
    "cta": "Esenler'de acil kepenk tamiri için kepengin açık mi kapalı mi kaldığını hemen bildirin.",
    "faults": [
      "raydan çıkma",
      "sigorta aştırma",
      "alıcı kart çalışmaması",
      "perde eğilmesi"
    ]
  },
  {
    "slug": "esenyurt",
    "name": "Esenyurt",
    "region": "Avrupa Yakası",
    "priority": 2,
    "neighborhoods": [
      "Akçaburgaz",
      "Cumhuriyet",
      "İncirtepe",
      "Kiraç",
      "Mehterçeşme",
      "Saadetdere",
      "Talatpaşa"
    ],
    "nearby": [
      "avcilar",
      "beylikduzu",
      "buyukcekmece"
    ],
    "localContext": "Esenyurt geniş konut alanları, sanayi çevreleri, depo girişleri ve hızla artan cadde ticaretiyle çok yoğun kepenk kullanımı olan ilçelerden biridir.",
    "businessProfile": "Kiraç ve Akcaburgaz'da sanayi-depo kepenkleri, Cumhuriyet ve Saadetdere'de mahalle dükkânları, İncirtepe'de cadde işletmeleri öne çıkar.",
    "accessNote": "İlçenin yoğun trafiği nedeniyle servis planı için mahalle ve net arıza belirtisi önemlidir.",
    "serviceNeed": "Esenyurt kepenk servisinde ağır kullanım kaynaklı motor ısınması, ray aşınması, kumanda alıcı kontrolü ve kilit güvenliği birlikte ele alınır.",
    "repairNeed": "Sık arızalar motorun ısınması, zincir gevşemesi, kepengin bir tarafa yatması, kumanda kaybı ve ray darbesidir.",
    "cta": "Esenyurt kepenk servisi için mahalle ve kepenk türünü ileterek hızlı teklif alabilirsiniz.",
    "faults": [
      "motor ısınması",
      "zincir gevşemesi",
      "kepengin yatması",
      "ray darbesi"
    ]
  },
  {
    "slug": "eyup",
    "name": "Eyüp",
    "region": "Avrupa Yakası",
    "priority": 2,
    "neighborhoods": [
      "Alibeyköy",
      "CirCır",
      "Eyüp Merkez",
      "Güzeltepe",
      "Kemerburgaz",
      "Rami"
    ],
    "nearby": [
      "gaziosmanpasa",
      "kagithane",
      "sultangazi"
    ],
    "localContext": "Eyüp'te tarihi merkez, sanayiye yakın atölyeler, depo alanları, cadde dükkânları ve Kemerburgaz hattındaki geniş işletmeler kepenk ihtiyaçını farklılaştırır.",
    "businessProfile": "Alibeyköy ve Rami'de depo-atölye kepenkleri, Eyüp merkezde cadde esnafı, Kemerburgaz tarafında geniş girişli kepenkler öne çıkar.",
    "accessNote": "Tarihi merkez ve dar sokaklarda servis saati, araç konumlandırma ve kepenge erişim önceden planlanır.",
    "serviceNeed": "Eyüp kepenk servisinde sanayi tipi motor, ray temizliği, kilit akşam, kumanda alıcı kart ve manuel kullanım sistemi birlikte kontrol edilir.",
    "repairNeed": "Sık arızalar raydan çıkma, motor kalkış zorlanması, kilit sertleşmesi, kumanda çekmemesi ve zincir sistemi sorunlarıdır.",
    "cta": "Eyüp kepenk tamiri için mahallenizi ve arızanın ne zamandır sürdüğünü bildirerek servis isteyin.",
    "faults": [
      "motor kalkış zorlanması",
      "kilit sertleşmesi",
      "kumanda çekmemesi",
      "zincir sorunu"
    ]
  },
  {
    "slug": "fatih",
    "name": "Fatih",
    "region": "Avrupa Yakası",
    "priority": 1,
    "neighborhoods": [
      "Aksaray",
      "Çapa",
      "Eminönü",
      "Fener",
      "Kocamustafapaşa",
      "Laleli",
      "Sultanahmet",
      "Topkapı"
    ],
    "nearby": [
      "beyoglu",
      "zeytinburnu",
      "eyup"
    ],
    "localContext": "Fatih'te tarihi çarşı dokusu, otel ve restoran yoğunluğu, tekstil-turizm ticareti ve dar Sokaklı dükkânlar kepenk sistemlerini çok aktif kullanır.",
    "businessProfile": "Laleli ve Aksaray'da tekstil ve turizm ticareti, Eminönü ve Sultanahmet'te turistik dükkânlar, Kocamustafapaşa ve Çapa'da mahalle esnafı öne çıkar.",
    "accessNote": "Tarihi yarimada trafiği, yükleme saatleri ve dar sokaklar servis planlamasında en kritik unsurlardır.",
    "serviceNeed": "Fatih kepenk servisinde kilit güvenliği, vitrin kepengi hizası, motor sesi, manuel açma sistemi ve ray içine yabancı madde kontrolü birlikte yapılır.",
    "repairNeed": "Sık arızalar kepengin sıkışması, kilit mekanizması arızası, motorun geç tepki vermesi, ray darbesi ve kumanda kaybıdır.",
    "cta": "Fatih'te kepenk arızası için kepengin konumunu ve sokak erişim durumunu paylaşarak hızlı servis isteyin.",
    "faults": [
      "kilit mekanizması arızası",
      "ray darbesi",
      "kumanda kaybı",
      "kepengin sıkışması"
    ]
  },
  {
    "slug": "gaziosmanpasa",
    "name": "Gaziosmanpaşa",
    "region": "Avrupa Yakası",
    "priority": 1,
    "neighborhoods": [
      "Bağlarbaşı",
      "Karadeniz",
      "Merkez",
      "Merve",
      "Pazarıçi",
      "Yeni Mahalle",
      "Yıldıztabya"
    ],
    "nearby": [
      "bayrampasa",
      "eyup",
      "sultangazi"
    ],
    "localContext": "Gaziosmanpaşa'da mahalle esnafı, ana cadde dükkânları, atölyeler ve pazar çevresi işletmeleri kepenk sistemlerine günlük güvenlik için ihtiyaç duyar.",
    "businessProfile": "Merkez ve Pazarıçi tarafında yoğun cadde ticareti, Karadeniz ve Yıldıztabya'da mahalle dükkânları, Merve'de servis işletmeleri öne çıkar.",
    "accessNote": "Yoğun cadde ve dar sokak yapısı nedeniyle servis için kepengin açık/kapalı kalma durumu önceden sorulur.",
    "serviceNeed": "Gaziosmanpaşa kepenk servisinde ray hizası, alıcı kart, motor torku, kumanda kaydı ve kilit sistemi birlikte kontrol edilmelidir.",
    "repairNeed": "Sık arızalar kepengin raydan çıkması, motorun sesli çalışması, kumandanın çalışmaması ve kepengin tam kapanmamasıdır.",
    "cta": "Gaziosmanpaşa kepenk servisi için mahalle ve kepengin durumunu bildirerek hızlı destek alın.",
    "faults": [
      "raydan çıkma",
      "motorun sesli çalışması",
      "kumandanın çalışmaması",
      "tam kapanmama"
    ]
  },
  {
    "slug": "gungoren",
    "name": "Güngören",
    "region": "Avrupa Yakası",
    "priority": 2,
    "neighborhoods": [
      "Güngören Merkez",
      "Güneşli",
      "Kazım Karabekir",
      "Merter",
      "Sanayi",
      "Tozkoparan"
    ],
    "nearby": [
      "bagcilar",
      "bahcelievler",
      "zeytinburnu"
    ],
    "localContext": "Güngören ve Merter hattında tekstil, atölye, depo ve cadde mağazaları nedeniyle kepenk sistemleri yoğun ve sert çalışma temposuna sahiptir.",
    "businessProfile": "Merter'de tekstil mağazaları, Sanayi ve Tozkoparan'da atölyeler, merkezde mahalle esnafı öne çıkar.",
    "accessNote": "Yükleme saatleri ve dar sokaklar servis planında önemlidir; özellikle atölye kepenklerinde parça hazırlığı gerekir.",
    "serviceNeed": "Güngören kepenk servisinde sık kullanım kaynaklı motor ısınması, ray aşınması, zincir sistemi ve kumanda alıcı kontrol edilir.",
    "repairNeed": "Sık arızalar zincir gevşemesi, motorun ısınıp durması, kepenk perdesinin eğilmesi ve alıcı kartın aralıklı çalışmasıdır.",
    "cta": "Güngören kepenk tamiri için Merter, Sanayi veya merkez lokasyon bilgisini paylaşarak servis isteyin.",
    "faults": [
      "zincir gevşemesi",
      "motor ısınıp durması",
      "perde eğilmesi",
      "alıcı kartın aralıklı çalışması"
    ]
  },
  {
    "slug": "kadikoy",
    "name": "Kadıköy",
    "region": "Anadolu Yakası",
    "priority": 1,
    "neighborhoods": [
      "Acıbadem",
      "Bostancı",
      "Caddebostan",
      "Fenerbahçe",
      "Fikirtepe",
      "Kozyatağı",
      "Moda",
      "Suadiye"
    ],
    "nearby": [
      "atasehir",
      "maltepe",
      "uskudar"
    ],
    "localContext": "Kadıköy'de butik mağazalar, restoranlar, sahil işletmeleri, pasaj dükkânları ve yoğun cadde ticareti kepenk sistemlerini hem güvenlik hem vitrin düzeni için kullanır.",
    "businessProfile": "Moda ve Bahariye çevresinde butik ve kafe işletmeleri, Bostancı ve Suadiye'de cadde mağazaları, Fikirtepe ve Kozyatağı'nda site dükkânları öne çıkar.",
    "accessNote": "Yoğun yaya trafiği ve park sorunu nedeniyle servis zamanlaması işletme saatlerine göre planlanır.",
    "serviceNeed": "Kadıköy kepenk servisinde sessiz çalışma, vitrin hizası, fotosel güvenliği, kumanda menzili ve ray temizliği birlikte kontrol edilir.",
    "repairNeed": "Sık arızalar kepengin vitrine sürtmesi, motor sesi, kumanda geç algılama, fotosel arızası ve ray içinde kir birikmesidir.",
    "cta": "Kadıköy kepenk servisi için mahalle ve işletme açılış/kapanış saatinizi ileterek servis planlayın.",
    "faults": [
      "vitrine sürtme",
      "motor sesi",
      "kumanda geç algılama",
      "fotosel arızası"
    ],
    "customContent": {
      "summary": "Kadıköy'de kepenk servisi ve tamiri: Bağdat Caddesi mağazalarından Bahariye pasajlarına, Fikirtepe şantiyelerinden Bostancı sahil esnafına kadar mahalle bazlı servis planlaması. Yönlendirme süresi ekip müsaitliği ve trafiğe göre paylaşılır.",
      "description": "Kadıköy kepenk servisi ve tamiri: Bağdat Caddesi, Bahariye, Moda ve Bostancı bölgelerinde motor, ray, kumanda ve yerinde arıza tespiti.",
      "answerBlock": {
        "title": "Kadıköy kepenk servisi ve tamiri – kısaca",
        "summary": "Olgun Kepenk, Kadıköy'de iki farklı ticaret dokusunu dikkate alır: Bahariye ve Moda'daki pasaj ile butik dükkânları ve Bağdat Caddesi hattındaki geniş mağaza vitrinleri. Fikirtepe'deki şantiye tozu, sahil hattındaki nem ve yoğun kullanımdaki motor yükü kontrol planını değiştirir.",
        "facts": [
          {
            "label": "Kapsam",
            "text": "Kepenk tamiri, bakım, motor-ray onarımı, kumanda tanıtma, alıcı kart, fotosel ve sıfır kepenk montajı."
          },
          {
            "label": "Müdahale alanı",
            "text": "Bahariye, Moda, Caferağa, Fenerbahçe, Caddebostan, Suadiye, Bostancı, Fikirtepe, Kozyatağı, Acıbadem ve çevresi."
          },
          {
            "label": "Kadıköy'e özgü durumlar",
            "text": "Gece geç kapanan kafe ve barlarda motor yorgunluğu; Fikirtepe şantiye tozunda ray kirlenmesi; sahil hattında nem kaynaklı pas."
          },
          {
            "label": "Servis planlama",
            "text": "Randevu saati; işletmenin çalışma düzeni, ekip müsaitliği, trafik ve park koşullarına göre paylaşılır."
          }
        ]
      },
      "sections": [
        {
          "title": "Bahariye'den Bağdat Caddesi'ne: Kadıköy'ün iki kepenk profili",
          "paragraphs": [
            "Kadıköy'de kepenk kullanımı iki farklı ticaret kültürüyle şekillenir. Bahariye Caddesi ve çevre sokaklarda pasaj içi dükkânlar, bağımsız kitapçılar, plakçılar ve butikler bulunur; burada kepenk dar girişlere ve pasaj içi düzeneye göre monte edilir, sessiz çalışma ve komşu dükkânla hizalama önceliklidir. Moda tarafında nostaljik tramvay hattının geçtiği güzergâh ve Yoğurtçu Parkı çevresindeki kafelerde ise akşam geç saatlere açık işletmeler olduğu için motorun gün içi çevrim sayısı yüksektir.",
            "Bağdat Caddesi hattında (Fenerbahçe, Caddebostan, Suadiye) tablo değişir: geniş vitrinli zincir mağazalar ve cadde trafiğiyle iç içe kepenkler öne çıkar. Bu hatta ölçü, rüzgâr yükü ve vitrin camıyla kepenk alt profili arasındaki hiza birlikte değerlendirilmelidir. Bakım aralığı üretici talimatı, çevre koşulları ve günlük kullanım sayısına göre belirlenir."
          ]
        },
        {
          "title": "Kadıköy'de öne çıkan arıza senaryoları",
          "paragraphs": [
            "Kadıköy'ün kullanım ve çevre koşullarında şu arıza senaryoları öne çıkabilir:"
          ],
          "highlights": [
            "Geç kapanan işletmelerde yüksek çevrim nedeniyle motor freninin yıpranması ve kalkış sesi",
            "Cadde trafiğinin kaldırdığı tozun raylarda birikmesiyle perdenin zorlanması (özellikle Bağdat Caddesi ve Bostancı istikameti)",
            "Fikirtepe'deki dönüşüm şantiyelerinin tozu nedeniyle alıcı kart ve kumanda alıcısındaki temas sorunları",
            "Güney cepheli vitrinlerde sabah güneşinin fotosel gözünü etkilemesi ve kepenğin tam kapanmaması",
            "Pazar tezgâhı ve pasaj dükkânlarında eski tip yay kilitlerinin aşınması"
          ]
        },
        {
          "title": "Fikirtepe ve Kozyatağı: dönüşüm bölgesinde kepenk bakımı",
          "paragraphs": [
            "Fikirtepe, İstanbul'un en yoğun kentsel dönüşüm bölgelerinden biri. Şantiye çalışmaları sürerken açılan site altı dükkânları ve showroom'lar için kepenk seçimi, inşaat tozuna dayanacak şekilde yapılmalıdır: toz, ray kanallarında birikir ve yağ ile karışarak macunumsu bir tabaka oluşturur. Bu tabaka, perdenin kalkış hızını düşürür ve motoru zorlar.",
            "Kozyatağı ve Acıbadem tarafındaki ofis bloklarının girişlerinde kullanım profili hafta içi yoğun olabilir. Plaza ve site girişlerinde bakım zamanı bina erişimini aksatmayacak bir pencereye alınmalı; ilk bakım tarihi üretici talimatı, montaj koşulları ve günlük çevrim sayısına göre belirlenmelidir."
          ]
        },
        {
          "title": "Bostancı ve sahil hattı: nemin kepenge etkisi",
          "paragraphs": [
            "Bostancı vapur iskelesi çevresindeki balıkçılar, sahil kafeleri ve Caddebostan–Fenerbahçe kordonundaki işletmeler, deniz etkisine açık cephelerdedir. Nemli ve tuzlu hava, ray ve zincir bölgesinde paslanmayı hızlandırır; sac kepenklerde dış yüzey boya bütünlüğü bozulduysa profillerin iç kısmında da korozyon başlar.",
            "Bu hatta pas kontrolü ve bakım aralığı cephe yönü, kaplama durumu ve kullanım sıklığına göre belirlenmelidir. Yeni sistemlerde alüminyum veya uygun galvaniz kaplı sac seçenekleri korozyon koşullarıyla birlikte karşılaştırılır."
          ]
        },
        {
          "title": "Kadıköy kepenk fiyatları ve ölçüm",
          "paragraphs": [
            "Tamir fiyatı arıza türüne ve değişen parçaya göre; sıfır kepenk fiyatı m² ölçüsü, malzeme (sac, sac görünümlü, alüminyum) ve motor gücüne göre belirlenir. Kadıköy'de yerinde kontrolün kapsamı ön görüşmede açıklanır; onarım öncesi net fiyat bildirilir.",
            "Bağdat Caddesi gibi geniş vitrinlerde ölçü büyüdükçe m² bedeli artar; pasaj dükkânlarında standart ölçüler daha ekonomiktir. Güncel m² fiyat tablosunu ve motor ek bedellerini görmek için:"
          ],
          "links": [
            {
              "title": "Kepenk Fiyatları 2026 – Güncel Tablo",
              "path": "/kepenk-fiyatlari"
            },
            {
              "title": "Ölçüm ve teklif formu",
              "path": "/teklif-formu"
            }
          ]
        },
        {
          "title": "Kadıköy'de servis süreci nasıl işliyor?",
          "paragraphs": [
            "Talebinizde mahalleyi (örneğin Caferağa mı, Fenerbahçe mi) ve kepengin açık mı kapalı mı kaldığını bildirin. Moda ve Bahariye sokaklarındaki park kısıtı ile işletmenin çalışma saati, uygun randevu zamanını belirler.",
            "İşlem sonrası güvenli açılma-kapanma testi yapılır. Uygulanacak garanti koşulları işlem ve parça türüne göre yazılı olarak belirtilir; yönlendirme süresi ekip müsaitliği ve trafiğe göre paylaşılır."
          ]
        },
        {
          "title": "Komşu ilçeler ve ilgili sayfalar",
          "paragraphs": [
            "Kadıköy merkezine yakın bölgelerde hizmet veren ilçe sayfalarımız:"
          ],
          "links": [
            {
              "title": "Ataşehir Kepenk Servisi",
              "path": "/atasehir"
            },
            {
              "title": "Maltepe Kepenk Servisi",
              "path": "/maltepe"
            },
            {
              "title": "Üsküdar Kepenk Servisi",
              "path": "/uskudar"
            },
            {
              "title": "Kepenk Tamiri – Motor, Ray, Kumanda",
              "path": "/kepenk-tamiri"
            },
            {
              "title": "Kepenk Arıza Teşhis Rehberi",
              "path": "/bilgi-merkezi/rehber/kepenk-ariza-teshis-rehberi"
            }
          ]
        }
      ],
      "faqs": [
        {
          "question": "Kadıköy'de gece kapanmayan kepenk için ne kadar hızlı gelirsiniz?",
          "answer": "Kepengin açık veya kapalı kaldığını, mahalleyi ve işletmenin kapanış saatini iletin. Uygun yönlendirme zamanı ekip müsaitliği ile trafik durumuna göre telefonla paylaşılır; sabit varış süresi taahhüt edilmez."
        },
        {
          "question": "Bağdat Caddesi'ndeki mağazam için estetik kepenk seçenekleri neler?",
          "answer": "Cadde cephesi işletmelerde sac görünümlü ve alüminyum kepenk profilleri, vitrin düzeniyle uyumlu renk seçenekleriyle uygulanır. Geniş vitrinlerde rüzgâr yükü hesaba katılarak motor gücü seçilir; ölçüm sonrası malzeme ve fiyat alternatifleri sunuyoruz."
        },
        {
          "question": "Fikirtepe'deki şantiye tozu kepenklerimi nasıl etkiler?",
          "answer": "İnşaat tozu raylarda birikir, yağla karışır ve perdenin hareketini zorlaştırır; alıcı kart ve kumanda alıcısında da temas sorunları yaratabilir. Bakım aralığı toz yoğunluğu, kullanım sayısı ve üretici talimatına göre kısaltılabilir."
        },
        {
          "question": "Salı Pazarı ve Perşembe Pazarı çevresindeki tezgâh kepenkleri için servis veriyor musunuz?",
          "answer": "Pazar bölgelerindeki tezgâh ve dükkân kepenklerinde yay kilidi, küçük ölçülü motor ve kumanda sistemi kontrol edilebilir. Randevu, pazar kurulumu ve sokak erişimini aksatmayacak zamana göre planlanır."
        },
        {
          "question": "Bostancı'daki dükkânım deniz kenarında; hangi malzemeyi önerirsiniz?",
          "answer": "Sahil hattında nem ve tuzlu hava sac kepenklerde paslanmayı hızlandırabilir. Alüminyum veya uygun galvaniz kaplı sac seçenekleri değerlendirilebilir; kontrol aralığı cephe yönü ve mevcut korozyon durumuna göre belirlenir."
        },
        {
          "question": "Pasaj içindeki dükkânımın kepengi komşuyla aynı hizada olmalı mı?",
          "answer": "Bahariye ve çevresindeki pasajlarda dükkân cepheleri ortak görünümdedir; kepenk alt profili ve kilit hizası komşu dükkânla uyumlu kurulmalıdır. Montajda pasaj düzenine göre ölçü alınıp hiza kontrolü yapılır."
        },
        {
          "question": "Kumandam kayboldu, yeni kumandayı Kadıköy'de tanıtabilir misiniz?",
          "answer": "Evet. Kayıp kumandalarda önce eski kumanda kodunu sistemden silip yeni değişken kodlu kumanda tanımlıyoruz. Yedek kumanda bulundurmanızı, personel değişiminde kod setini yeniletmenizi öneriyoruz."
        },
        {
          "question": "Kadıköy'de sıfır kepenk montajı ne kadar sürede tamamlanır?",
          "answer": "Montaj süresi ölçü, malzeme ve saha koşulları görüldükten sonra paylaşılır. Pasaj içi ve ölçüye özel alüminyum sistemlerde üretim süresi eklenir; ölçüm sonrası net takvim veriyoruz."
        }
      ]
    }
  },
  {
    "slug": "kagithane",
    "name": "Kağıthane",
    "region": "Avrupa Yakası",
    "priority": 1,
    "neighborhoods": [
      "Çağlayan",
      "Gültepe",
      "Hamidiye",
      "Merkez",
      "Seyrantepe",
      "Talatpaşa"
    ],
    "nearby": [
      "eyup",
      "sariyer",
      "sisli"
    ],
    "localContext": "Kağıthane'de sanayi geçmişi olan atölye alanları, ofis plazaları, cadde dükkânları ve depo girişleri kepenk servis ihtiyaçını çeşitlendirir.",
    "businessProfile": "Çağlayan ve Gültepe'de cadde esnafı, Seyrantepe'de depo ve ofis girişleri, Hamidiye ve merkezde mahalle işletmeleri öne çıkar.",
    "accessNote": "Dik sokaklar, otopark girişleri ve plaza çevreleri servis ekipmaninin doğru seçilmesini gerektirir.",
    "serviceNeed": "Kağıthane kepenk servisinde motor torku, ray sabitlemesi, kumanda alıcı, fotosel ve manuel açma düzeni birlikte kontrol edilir.",
    "repairNeed": "Sık arızalar motorun kepengi kaldırmakta zorlanması, alıcı kart arızası, ray yamulması ve kepengin tam kapanmamasıdır.",
    "cta": "Kağıthane kepenk tamiri için mahalle ve arızanın motor mu mekanik mi olduğunu paylaşın.",
    "faults": [
      "motorun kaldırmakta zorlanması",
      "alıcı kart arızası",
      "ray yamulması",
      "tam kapanmama"
    ]
  },
  {
    "slug": "kartal",
    "name": "Kartal",
    "region": "Anadolu Yakası",
    "priority": 3,
    "neighborhoods": [
      "Aydos",
      "Cevizli",
      "Hürriyet",
      "Kartal Merkez",
      "Orhantepe",
      "Yakacık",
      "Yalı"
    ],
    "nearby": [
      "maltepe",
      "pendik",
      "sancaktepe"
    ],
    "localContext": "Kartal'da sanayi çevreleri, sahil hattındaki işletmeler, site dükkânları ve depo girişleri kepenk sistemlerini farklı şartlarda kullanır.",
    "businessProfile": "Cevizli ve Kartal merkezde cadde işletmeleri, Yakacık ve Aydos tarafında depo/garaj kepenkleri, sahil hattında restoran ve kafe ihtiyaçları öne çıkar.",
    "accessNote": "Sahil ve E-5 akslarindaki farklı trafik koşulları servis saatini etkiler.",
    "serviceNeed": "Kartal kepenk servisinde motor gücü, ray temizliği, fotosel, kumanda sistemi ve sahil nemine bağlı pas kontrolü birlikte yapılır.",
    "repairNeed": "Sık arızalar ray sertleşmesi, motor kalkış problemi, fotosel hatası ve kumandanın çalışmamasıdır.",
    "cta": "Kartal kepenk servisi için mahalle ve kepenk tipinizi bildirerek hızlı destek alın.",
    "faults": [
      "ray sertleşmesi",
      "motor kalkış problemi",
      "fotosel hatası",
      "kumandanın çalışmaması"
    ]
  },
  {
    "slug": "kucukcekmece",
    "name": "Küçükçekmece",
    "region": "Avrupa Yakası",
    "priority": 3,
    "neighborhoods": [
      "Atakent",
      "Cennet",
      "Halkalı",
      "Kanarya",
      "Sefaköy",
      "Yarımburgaz"
    ],
    "nearby": [
      "avcilar",
      "bahcelievler",
      "basaksehir"
    ],
    "localContext": "Küçükçekmece'de Halkalı ve Atakent gibi yeni ticari alanlar, Sefaköy gibi yoğun cadde bölgeleri ve sanayiye yakın işletmeler kepenk servis talebini artırır.",
    "businessProfile": "Sefaköy'de cadde esnafı, Halkalı ve Atakent'te site mağazaları, Kanarya ve Yarımburgaz'da depo ve mahalle işletmeleri öne çıkar.",
    "accessNote": "Metrobus, E-5 ve Halkalı bağlantıları servis planında trafik saatlerini önemli hale getirir.",

    "customContent": {
      "description": "Küçükçekmece kepenk tamiri: Halkalı, Atakent, Sefaköy, Kanarya ve Yarımburgaz bölgelerinde motor, kumanda ve ray arızalarına yerinde teknik çözüm. Yerinde teknik kontrol ve işlem öncesi fiyat bilgisi. ☎ 0501 081 71 61."
    },    "serviceNeed": "Küçükçekmece kepenk servisinde kumanda alıcı, motor sesi, ray hizası ve güvenli kapanma birlikte kontrol edilir.",
    "repairNeed": "Sık arızalar motorun geç tepki vermesi, kumanda kodu silinmesi, kepengin eğri kapanması ve rayda darbedir.",
    "cta": "Küçükçekmece kepenk tamiri için bulunduğunuz mahalleyi ve arıza belirtisini paylaşabilirsiniz.",
    "faults": [
      "geç tepki",
      "kumanda kodu silinmesi",
      "eğri kapanma",
      "ray darbesi"
    ]
  },
  {
    "slug": "maltepe",
    "name": "Maltepe",
    "region": "Anadolu Yakası",
    "priority": 3,
    "neighborhoods": [
      "Altayçeşme",
      "Bağlarbaşı",
      "Cevizli",
      "Dragos",
      "Feyzullah",
      "Gülsuyu",
      "Küçükyalı"
    ],
    "nearby": [
      "kadikoy",
      "kartal",
      "sancaktepe"
    ],
    "localContext": "Maltepe'de sahil hattındaki işletmeler, site dükkânları, garaj kepenkleri ve cadde mağazaları kepenk servis ihtiyaçını belirler.",
    "businessProfile": "Küçükyalı ve Dragos'ta sahil işletmeleri, Cevizli ve Altayçeşme'de cadde dükkânları, Gülsuyu'nda mahalle esnafı öne çıkar.",
    "accessNote": "Sahil ve E-5 hattındaki farklı erişim koşulları ekip planlamasında dikkate alınır.",
    "serviceNeed": "Maltepe kepenk servisinde nem etkisi, ray temizliği, motor kalkış gücü, fotosel ve kumanda menzili birlikte kontrol edilir.",
    "repairNeed": "Sık arızalar ray sertleşmesi, motorun sesli çalışması, kepengin yarıda kalması ve kumandanın zayıf çekmesidir.",
    "cta": "Maltepe kepenk servisi için mahalle, kepenk turu ve aciliyet bilgisini gönderin.",
    "faults": [
      "ray sertleşmesi",
      "sesli motor",
      "yarıda kalma",
      "zayıf kumanda çekimi"
    ]
  },
  {
    "slug": "pendik",
    "name": "Pendik",
    "region": "Anadolu Yakası",
    "priority": 3,
    "neighborhoods": [
      "Aydınlı",
      "Kaynarca",
      "Kurtköy",
      "Pendik Merkez",
      "Yenişehir"
    ],
    "nearby": [
      "kartal",
      "sancaktepe",
      "tuzla"
    ],
    "localContext": "Pendik'te sanayi, lojistik, havaalanı bağlantısı, site dükkânları ve sahil işletmeleri kepenk ihtiyaçlarını çeşitlendirir.",
    "businessProfile": "Kurtköy ve Yenişehir'de yeni ticari alanlar, Kaynarca ve merkezde cadde esnafı, Aydınlı'da depo ve sanayi kullanımı öne çıkar.",
    "accessNote": "İlçe geniş olduğu için servis yönlendirmesinde mahalle, ana yol ve kepenk ölçüsü belirleyicidir.",
    "serviceNeed": "Pendik kepenk servisinde ağır kepenk motorları, kumanda alıcıları, ray sabitlemesi ve fotosel güvenliği birlikte kontrol edilir.",
    "repairNeed": "Sık arızalar motor tork kaybı, ray yamulması, kumanda kaybı ve zincir gevşemesi.",
    "cta": "Pendik kepenk tamiri için mahallenizi ve kepengin ağırlık/ölçü bilgisini paylaşabilirsiniz.",
    "faults": [
      "motor tork kaybı",
      "ray yamulması",
      "kumanda kaybı",
      "zincir gevşemesi"
    ]
  },
  {
    "slug": "sancaktepe",
    "name": "Sancaktepe",
    "region": "Anadolu Yakası",
    "priority": 2,
    "neighborhoods": [
      "Emek",
      "Meclis",
      "Mevlana",
      "Pınar",
      "Sarıgazi",
      "Yenidoğan"
    ],
    "nearby": [
      "cekmekoy",
      "kartal",
      "umraniye"
    ],
    "localContext": "Sancaktepe'de yeni konut alanları, mahalle dükkânları, sanayiye yakın işletmeler ve garaj kepenkleri bir arada bulunur.",
    "businessProfile": "Sarıgazi ve Yenidoğan'da mahalle esnafı, Mevlana ve Meclis'te site dükkânları, Emek tarafında atölye ve depo girişleri öne çıkar.",
    "accessNote": "Site ve mahalle sokaklarında kepenge erişim için net adres ve blok bilgisi servis planını hızlandırır.",
    "serviceNeed": "Sancaktepe kepenk servisinde garaj ve dükkân kepenkleri için limit ayarı, motor sesi, kumanda alıcı ve ray temizliği kontrol edilir.",
    "repairNeed": "Sık arızalar kepengin yarıda durması, limit ayarı bozulması, kumanda tanıtma sorunu ve rayda toz birikmesidir.",
    "cta": "Sancaktepe kepenk servisi için site/mahalle bilgisini ve kepengin hangi konumda kaldığını iletin.",
    "faults": [
      "yarıda durma",
      "limit ayarı bozulması",
      "kumanda tanıtma sorunu",
      "rayda toz"
    ]
  },
  {
    "slug": "sariyer",
    "name": "Sarıyer",
    "region": "Avrupa Yakası",
    "priority": 1,
    "neighborhoods": [
      "Ayazağa",
      "Emirgan",
      "İstinye",
      "Maslak",
      "Sarıyer Merkez",
      "Tarabya",
      "Yeniköy"
    ],
    "nearby": [
      "besiktas",
      "kagithane",
      "sisli"
    ],
    "localContext": "Sarıyer'de Maslak ofisleri, İstinye ve Tarabya sahil işletmeleri, villa garajları ve cadde dükkânları kepenk servis ihtiyaçını yüksek kalite beklentisiyle birleştirir.",
    "businessProfile": "Maslak ve Ayazağa'da plaza/depo kepenkleri, İstinye ve Tarabya'da restoran-kafe işletmeleri, merkezde mahalle esnafı öne çıkar.",
    "accessNote": "Site, villa ve plaza girişlerinde servis prosedürü, güvenlik kaydı ve otopark erişimi önceden planlanır.",
    "serviceNeed": "Sarıyer kepenk servisinde sessiz çalışma, motor fren kontrolü, kumanda menzili, fotosel ve ray temizliği birlikte yapılır.",
    "repairNeed": "Sık arızalar motor sesi, kumanda geç algılama, garaj kepenginin yarıda kalması ve sahil nemine bağlı ray sertleşmesi.",
    "cta": "Sarıyer kepenk tamiri için lokasyon turu ve güvenlik girişi bilgisini paylaşarak servis isteyin.",
    "faults": [
      "motor sesi",
      "kumanda geç algılama",
      "garaj kepenginin yarıda kalması",
      "sahil nemi kaynaklı ray sertleşmesi"
    ]
  },
  {
    "slug": "silivri",
    "name": "Silivri",
    "region": "Avrupa Yakası",
    "priority": 1,
    "neighborhoods": [
      "Çanta",
      "Kavaklı",
      "Ortaköy",
      "Selimpaşa",
      "Silivri Merkez"
    ],
    "nearby": [
      "buyukcekmece",
      "catalca",
      "beylikduzu"
    ],
    "localContext": "Silivri'de sahil işletmeleri, sanayi alanları, depo girişleri, yazlik bölgeler ve merkez dükkânları kepenk sistemlerini farklı sezonlarda yoğun kullanır.",
    "businessProfile": "Selimpaşa ve merkezde cadde/sahil işletmeleri, Çanta ve Ortaköy'de depo ve üretim alanları, Kavaklı'da ticari dükkânlar öne çıkar.",
    "accessNote": "İlçe mesafesi ve sahil-sanayi farkı nedeniyle ekip arıza türüne göre doğru parça ile yönlendirilir.",
    "serviceNeed": "Silivri kepenk servisinde pas kontrolü, ağır kepenk motor gücü, ray temizliği ve kumanda alıcı performansı birlikte değerlendirilir.",
    "repairNeed": "Sık arızalar paslanmaya bağlı sert çalışma, motor kalkış zorlanması, kepengin raydan çıkması ve alıcı kart problemidir.",
    "cta": "Silivri kepenk servisi için merkez, sahil veya sanayi lokasyonunuzu belirterek kayıt açın.",
    "faults": [
      "paslanmaya bağlı sert çalışma",
      "motor kalkış zorlanması",
      "raydan çıkma",
      "alıcı kart problemi"
    ]
  },
  {
    "slug": "sultanbeyli",
    "name": "Sultanbeyli",
    "region": "Anadolu Yakası",
    "priority": 3,
    "neighborhoods": [
      "Abdurrahmangazi",
      "Battalgazi",
      "Mecidiye",
      "Mimar Sinan",
      "Necip Fazıl",
      "Yavuz Selim"
    ],
    "nearby": [
      "pendik",
      "sancaktepe",
      "tuzla"
    ],
    "localContext": "Sultanbeyli'de mahalle dükkânları, oto servisleri, depo girişleri ve cadde üzerindeki işletmeler kepenk sistemlerini günlük güvenlik için kullanır.",
    "businessProfile": "Mimar Sinan ve Battalgazi'de cadde esnafı, Mecidiye ve Yavuz Selim'de servis ve atölye işletmeleri öne çıkar.",
    "accessNote": "Mahalle sokaklarında araç erişimi ve kepengin bulunduğu cephe servis planında dikkate alınır.",
    "serviceNeed": "Sultanbeyli kepenk servisinde motor torku, ray temizliği, kumanda alıcı ve kilit sistemi birlikte kontrol edilir.",
    "repairNeed": "Sık arızalar motorun zor kalkması, kepengin tam kapanmaması, kumanda alıcı arızası ve rayda darbedir.",
    "cta": "Sultanbeyli kepenk tamiri için mahallenizi ve kepengin kapalı/açık durumunu paylaşın.",
    "faults": [
      "zor kalkma",
      "tam kapanmama",
      "alıcı arızası",
      "ray darbesi"
    ]
  },
  {
    "slug": "sultangazi",
    "name": "Sultangazi",
    "region": "Avrupa Yakası",
    "priority": 3,
    "neighborhoods": [
      "Cebeci",
      "Esentepe",
      "Gazi",
      "Habibler",
      "Sultançiftliği",
      "Yunus Emre"
    ],
    "nearby": [
      "gaziosmanpasa",
      "eyup",
      "basaksehir"
    ],
    "localContext": "Sultangazi'de mahalle dükkânları, sanayiye yakın işletmeler, depo girişleri ve ana cadde perakendesi kepenk sistemlerini yoğun kullanır.",
    "businessProfile": "Gazi ve Sultançiftliği'nde cadde ticareti, Cebeci ve Habibler'de depo/atölye kullanımı, Esentepe'de mahalle esnafı öne çıkar.",
    "accessNote": "Yoğun cadde ve mahalle sokaklarında servis için net tarif ve kepengin erişim durumu önemlidir.",
    "serviceNeed": "Sultangazi kepenk servisinde motor gücü, ray sabitlemesi, kumanda alıcı ve mekanik darbe kontrolü birlikte yapılır.",
    "repairNeed": "Sık arızalar raydan çıkma, kepenk perdesinde eğilme, motorun sesli çalışması ve kumandanın çalışmamasıdır.",
    "cta": "Sultangazi kepenk servisi için mahalle ve arızanın mekanik mi elektronik mi olduğunu belirtin.",
    "faults": [
      "raydan çıkma",
      "perde eğilmesi",
      "sesli motor",
      "kumanda arızası"
    ]
  },
  {
    "slug": "sile",
    "name": "Şile",
    "region": "Anadolu Yakası",
    "priority": 3,
    "neighborhoods": [
      "Ağva",
      "Çavuş",
      "Kumbaba",
      "Merkez",
      "Sofular"
    ],
    "nearby": [
      "beykoz",
      "cekmekoy",
      "sancaktepe"
    ],
    "localContext": "Şile'de sahil işletmeleri, sezonluk dükkânlar, butik oteller ve merkeze yayılan mahalle ticareti kepenk sistemlerini özellikle sezon öncesi bakıma ihtiyaç duyar.",
    "businessProfile": "Ağva ve Kumbaba'da sezonluk turizm işletmeleri, merkezde cadde dükkânları, Sofular tarafında depo ve küçük işletmeler öne çıkar.",
    "accessNote": "İlçe mesafesi nedeniyle servis öncesinde arıza tanımı ve parça ihtiyaçı netleştirilmelidir.",
    "serviceNeed": "Şile kepenk servisinde nem-pas kontrolü, ray temizliği, motor kalkış testi ve manuel kullanım sistemi birlikte kontrol edilir.",
    "repairNeed": "Sık arızalar uzun süre kapalı kalma sonrası motor zorlanması, pas kaynaklı ray sertleşmesi, kumanda çekim sorunu ve kilit şişmedir.",
    "cta": "Şile kepenk servisi için işletmenin sezonluk mu sürekli mi çalıştığını belirterek servis isteyin.",
    "faults": [
      "uzun kapalı kalma sonrası zorlanma",
      "pas kaynaklı ray sertleşmesi",
      "kumanda çekim sorunu",
      "kilit şişme"
    ]
  },
  {
    "slug": "sisli",
    "name": "Şişli",
    "region": "Avrupa Yakası",
    "priority": 3,
    "neighborhoods": [
      "Bomonti",
      "Esentepe",
      "Feriköy",
      "Gülbahar",
      "Harbiye",
      "Kurtuluş",
      "Mecidiyeköy",
      "Nişantaşı",
      "Okmeydanı",
      "Pangaltı",
      "Teşvikiye"
    ],
    "nearby": [
      "besiktas",
      "beyoglu",
      "kagithane"
    ],
    "localContext": "Şişli'de ofisler, pasajlar, butik mağazalar, klinikler, restoranlar ve yoğun cadde ticareti kepenk sistemlerini hem güvenlik hem prestij için kullanır.",
    "businessProfile": "Nişantaşı ve Harbiye'de butik ve klinikler, Mecidiyeköy'de ofis ve cadde dükkânları, Bomonti ve Feriköy'de atölye ve perakende alanları öne çıkar.",
    "accessNote": "Yoğun trafik, otopark ve bina giriş prosedürleri nedeniyle servis saati önceden planlanır.",
    "serviceNeed": "Şişli kepenk servisinde sessiz çalışma, vitrin hizası, fotosel güvenliği, kumanda sistemi ve motor fren sesi birlikte kontrol edilir.",
    "repairNeed": "Sık arızalar motor sesi, kepengin vitrine sürtmesi, kumanda geç algılama ve fotosel hatasıdır.",
    "cta": "Şişli kepenk tamiri için bina girişi ve işletme çalışma saatinizi paylaşabilirsiniz.",
    "faults": [
      "motor sesi",
      "vitrine sürtme",
      "kumanda geç algılama",
      "fotosel hatası"
    ],
    "customContent": {
      "summary": "Şişli'de kepenk servisi ve tamiri: Mecidiyeköy plaza girişlerinden Nişantaşı butiklerine, Bomonti dönüşüm bölgesinden Okmeydanı atölyelerine kadar kurumsal ve butik ölçekte planlı servis.",
      "description": "Şişli kepenk servisi ve tamiri: Mecidiyeköy, Nişantaşı, Bomonti ve Kurtuluş bölgelerinde motor, ray, kumanda ve bakım desteği.",
      "answerBlock": {
        "title": "Şişli kepenk servisi ve tamiri – kısaca",
        "summary": "Şişli'nin kullanım profili ilçeye göre değişir: Büyükdere Caddesi–Mecidiyeköy hattında çok girişli plaza ve AVM cepheleri; Nişantaşı ve Teşvikiye'de estetik ile sessizliğin öne çıktığı butik vitrinler; Bomonti, Feriköy ve Okmeydanı'nda geniş açıklıklı atölye girişleri bulunur.",
        "facts": [
          {
            "label": "Kapsam",
            "text": "Kurumsal bakım anlaşmaları, kepenk tamiri, motor-ray onarımı, estetik butik kepenkler, geniş açıklıklı atölye kepenkleri, fotosel ve güvenlik entegrasyonu."
          },
          {
            "label": "Müdahale alanı",
            "text": "Mecidiyeköy, Esentepe, Gülbahar, Nişantaşı, Teşvikiye, Harbiye, Kurtuluş, Pangaltı, Bomonti, Feriköy, Okmeydanı hattı."
          },
          {
            "label": "Şişli'ye özgü durumlar",
            "text": "Hafta içi kurumsal saat kısıtları ve trafik yoğunluğu; rezidans girişlerinde gece gürültü hassasiyeti; sanayi bölgesinde ağır kullanım."
          },
          {
            "label": "Servis planlama",
            "text": "Randevu saati; bina prosedürü, işletme çalışma düzeni, ekip müsaitliği ve trafik durumuna göre paylaşılır."
          }
        ]
      },
      "sections": [
        {
          "title": "Büyükdere Caddesi hattı: plaza ve AVM girişlerinde kepenk yönetimi",
          "paragraphs": [
            "Büyükdere Caddesi ve Mecidiyeköy, İstanbul'un ofis yoğunluğu en yüksek akslarından biridir. Plaza girişleri, banka şube cepheleri, AVM yan kapıları ve kurumsal showroom'lar bu hatta sıralanır. Burada kepenk yönetimi bir bina operasyonu meselesidir: tek bir girişin arızası, sabah binlerce personelin giriş akışını etkiler.",
            "Çok girişli binalarda tüm kepenklerin envantere alınması ve ortak bakım takviminde kontrol edilmesi değerlendirilebilir. Motor, kart ve kumanda uyumluluğu kayıt altına alınarak olası parça ihtiyacı önceden belirlenir; servis saati bina prosedürüne göre planlanır."
          ]
        },
        {
          "title": "Nişantaşı ve Teşvikiye: prestij cephesinde sessiz ve estetik kepenk",
          "paragraphs": [
            "Nişantaşı ve Teşvikiye'de butik mağaza, galeri ve özel klinik cepheleri vitrinin kendisidir. Burada kepenk iki şartı aynı anda sağlamalıdır: kapanınca güvenlik, açıkken görünümden hiçbir şey kaybetmemek. Alüminyum ve sac görünümlü profiller, cephe rengiyle uyumlu seçimlerle uygulanır.",
            "Bu bölgede sessiz çalışma kritiktir; kapanış sırasında oluşan gıcırtı komşu kullanımları etkileyebilir. Motor freni, ray temizliği ve uygun yağlama bakım sırasında birlikte değerlendirilir; randevu işletmenin çalışma saatine göre netleştirilir."
          ]
        },
        {
          "title": "Bomonti ve Feriköy: dönüşen sanayi dokusunda kepenk",
          "paragraphs": [
            "Bomonti ve Feriköy, eski sanayi dokusunun rezidans, ofis ve eğlence mekânlarına dönüştüğü bir bölge. Bu dönüşüm, iki tip kepenk ihtiyacını yan yana getirir: eski atölye ve deposu girişlerinde ağır kullanıma dayanıklı geniş kepenkler; yeni açılan kafe, stüdyo ve showroom'larda estetik ve sessiz sistemler.",
            "Okmeydanı sanayi sitesi çevresinde yük rampaları ve atölye kapıları için yüksek çevrimli santral motor gerekebilir. Ağır perdede yetersiz motor seçimi erken zorlanmaya yol açabilir; güç hesabı perde ağırlığı ve günlük çevrim sayısına göre yapılmalıdır."
          ]
        },
        {
          "title": "Şişli'de sık gördüğümüz arızalar",
          "paragraphs": [
            "Bölgenin kullanım profili, belirli arızaları öne çıkarır:"
          ],
          "highlights": [
            "Plaza girişlerinde yoğun çevrim nedeniyle motor fren sesi ve limit kayması",
            "Kurumsal cephelerde fotosel hizasının temizlik ekipleri tarafından kaydırılması",
            "Rezidans girişlerinde gece çalışmada komşu şikâyeti yaratan ray sesi",
            "Sanayi bölgesinde ağır perdelerde zincir ve dişli aşınması",
            "Trafik yoğunluğu nedeniyle servis penceresinin kısıtlı olduğu hafta içi saatler"
          ]
        },
        {
          "title": "Kurumsal ve site yönetimlerine toplu servis planı",
          "paragraphs": [
            "Şişli'de birden fazla girişi veya dükkânı olan yönetimler için tüm kepenklerin tek envanterde listelendiği ve bakım tarihlerinin ortak takip edildiği bir plan hazırlanabilir. Bu yapı parça uyumluluğunu ve işlem geçmişini tek noktada izlemeyi kolaylaştırır.",
            "Plan; kepenk adedi, ölçüleri ve kullanım yoğunluğuna göre hazırlanır. Teklif için yönetimizin iletişim bilgisiyle bize ulaşmanız yeterli."
          ]
        },
        {
          "title": "Şişli kepenk fiyatları",
          "paragraphs": [
            "Tamir ücreti arıza ve parçaya göre; sıfır kepenk m², malzeme ve motor gücüne göre belirlenir. Nişantaşı'ndaki butik ölçülerle sanayi bölgesindeki geniş açıklıklar arasında fiyat farkı doğaldır. Yerinde kontrolün kapsamı ön görüşmede açıklanır; onaylı fiyat alınmadan işlem yapılmaz."
          ],
          "links": [
            {
              "title": "Kepenk Fiyatları 2026 – Güncel Tablo",
              "path": "/kepenk-fiyatlari"
            },
            {
              "title": "Otomatik Kepenk Servisi (İstanbul genel)",
              "path": "/kepenk-servisi"
            }
          ]
        },
        {
          "title": "Şişli'de servis planlaması ve komşu ilçeler",
          "paragraphs": [
            "Şişli'de hafta içi trafik ve bina prosedürleri nedeniyle randevu saatini önceden netleştirmek işi hızlandırır: plaza girişleri için site yönetimi onayı, Nişantaşı butikleri için kapanış sonrası pencere, sanayi bölgesi için gün içi esnek saat planlanabilir.",
            "Komşu ilçe sayfalarımız:"
          ],
          "links": [
            {
              "title": "Beşiktaş Kepenk Servisi",
              "path": "/besiktas"
            },
            {
              "title": "Beyoğlu Kepenk Servisi",
              "path": "/beyoglu"
            },
            {
              "title": "Kağıthane Kepenk Servisi",
              "path": "/kagithane"
            },
            {
              "title": "Kepenk Bakım Rehberi",
              "path": "/bilgi-merkezi/rehber/kepenk-bakim-rehberi"
            }
          ]
        }
      ],
      "faqs": [
        {
          "question": "Şişli'de plaza girişlerimiz için yıllık bakım anlaşması yapabilir miyiz?",
          "answer": "Plaza, rezidans ve çok dükkânlı yönetimler için kepenk adedi, ölçüleri ve kullanım yoğunluğuna göre ortak envanter ile bakım planı hazırlanabilir. Kapsam ve randevu koşulları teklif aşamasında yazılı olarak netleştirilir."
        },
        {
          "question": "Nişantaşı'ndaki butiğim için kepenk görünümü önemli; hangi seçenekler var?",
          "answer": "Alüminyum ve sac görünümlü profiller cephe rengiyle uyumlu uygulanır; sessiz çalışma için motor fren ayarı ve ray bakımı düzenli yapılır. Ölçüm sırasında cephe fotoğrafıyla birlikte malzeme ve renk alternatifleri sunuyoruz."
        },
        {
          "question": "Mecidiyeköy'deki ofis binamızın kepenği sabah açılmadı; ne kadar hızlı gelirsiniz?",
          "answer": "Kepengin açık veya kapalı kaldığını, giriş sayısını ve arıza belirtisini iletin. Şişli içindeki yönlendirme zamanı ekip müsaitliği, trafik, bina erişimi ve gerekli parça olasılığına göre paylaşılır."
        },
        {
          "question": "Okmeydanı'ndaki atölyem için ağır bir kepenk motoru gerekli; ölçüm yapıyor musunuz?",
          "answer": "Ağır perdelerde motor seçimi perde ağırlığı ve günlük çevrim sayısına göre yapılır; santral motor ve zincirli sistem seçenekleri ölçüm sonrası karşılaştırılır. Yetersiz motor gücü erken zorlanmaya yol açabilir."
        },
        {
          "question": "Rezidans girişimizin kepenki gece gürültü yapıyor; çözüm var mı?",
          "answer": "Ray kuruluğu, rulman aşınması veya fren ayarı gece sesin başlıca nedenleridir. Ray temizliği, yağlama ve fren kalibrasyonu genellikle sorunu çözer; perde hiza bozukluğu varsa o da düzeltilir."
        },
        {
          "question": "Bomonti'deki eski atölye kepenklerim yenilenebilir mi?",
          "answer": "Evet. Perde ve ray sağlamsa motorlu sisteme çevirme, yıpranmışsa ölçüye özel yenileme yapılır. Dönüşüm bölgelerinde yeni kullanım planına (kafe, stüdyo, showroom) uygun sessiz ve estetik sistemler öneriyoruz."
        },
        {
          "question": "Kurtuluş'taki dükkânım için cumartesi servisi alabilir miyim?",
          "answer": "Cumartesi için uygunluk telefon veya WhatsApp üzerinden kontrol edilmelidir. Randevu saati ekip müsaitliği, trafik ve işletmenin çalışma düzenine göre netleştirilir."
        },
        {
          "question": "Fotoseller temizlik sonrası kaymış, kepenk tam kapanmıyor; acil müdahale eder misiniz?",
          "answer": "Fotosel hizası, kablo bağlantısı ve kontrol kartı birlikte incelenmelidir. Yerinde ayar yeterli değilse arızalı sensör veya bağlantı için gerekli işlem ve parça uygulama öncesinde açıklanır."
        }
      ]
    }
  },
  {
    "slug": "tuzla",
    "name": "Tuzla",
    "region": "Anadolu Yakası",
    "priority": 3,
    "neighborhoods": [
      "Aydınlı",
      "Içmeler",
      "Orhanlı",
      "Postane",
      "Tepeören",
      "Tuzla Merkez"
    ],
    "nearby": [
      "pendik",
      "sancaktepe",
      "kartal"
    ],
    "localContext": "Tuzla'da tersane ve sanayi çevreleri, lojistik alanlar, depo girişleri ve merkez dükkânları kepenk sistemlerini ağır kullanım koşullarında çalıştırır.",
    "businessProfile": "Orhanlı ve Tepeören'de depo/sanayi kepenkleri, İçmeler ve merkezde cadde işletmeleri, Aydınlı'da servis ve üretim alanları öne çıkar.",
    "accessNote": "Sanayi lokasyonlarında kepenk ölçüsü ve motor tipi önceden bilinirse servis ekibi doğru parça ile gelir.",
    "serviceNeed": "Tuzla kepenk servisinde santral motor, zincir sistemi, ray sabitlemeleri, elektrik beslemesi ve güvenlik kilidi birlikte kontrol edilir.",
    "repairNeed": "Sık arızalar ağır kepenk motor yorgunluğu, zincir kopması, ray darbesi ve elektrik besleme sorunlarıdır.",
    "cta": "Tuzla kepenk servisi için motor tipi ve kepenk ölçüsünü paylaşarak hızlı destek alın.",
    "faults": [
      "ağır kepenk motor yorgunluğu",
      "zincir kopması",
      "ray darbesi",
      "elektrik besleme sorunu"
    ]
  },
  {
    "slug": "umraniye",
    "name": "Ümraniye",
    "region": "Anadolu Yakası",
    "priority": 3,
    "neighborhoods": [
      "Atakent",
      "Çakmak",
      "Dudullu",
      "Ihlamurkuyu",
      "Namık Kemal",
      "Şerifali"
    ],
    "nearby": [
      "atasehir",
      "cekmekoy",
      "uskudar"
    ],
    "localContext": "Ümraniye'de sanayi, ofis, depo, site altı dükkân ve yoğun cadde ticareti kepenk servis talebini Anadolu Yakası'nda öne çıkarır.",
    "businessProfile": "Dudullu ve Şerifali'de sanayi-depo kepenkleri, Çakmak ve Atakent'te cadde/site dükkânları, Ihlamurkuyu'da mahalle esnafı öne çıkar.",
    "accessNote": "Sanayi ve cadde lokasyonları arasındaki fark servis ekipmani ve parça seçimini etkiler.",
    "serviceNeed": "Ümraniye kepenk servisinde motor gücü, kumanda alıcı, ray sabitlemesi, fotosel ve kilit güvenliği birlikte kontrol edilir.",
    "repairNeed": "Sık arızalar motor tork kaybı, raydan çıkma, kumanda alıcı problemi ve kepengin tam kapanmamasıdır.",
    "cta": "Ümraniye kepenk tamiri için Dudullu, Şerifali veya merkez lokasyon bilgisini ekleyin.",
    "faults": [
      "motor tork kaybı",
      "raydan çıkma",
      "alıcı problemi",
      "tam kapanmama"
    ]
  },
  {
    "slug": "uskudar",
    "name": "Üsküdar",
    "region": "Anadolu Yakası",
    "priority": 3,
    "neighborhoods": [
      "Acıbadem",
      "Altunizade",
      "Bulgurlu",
      "Kısıklı",
      "Kuzguncuk",
      "Üsküdar Merkez"
    ],
    "nearby": [
      "atasehir",
      "beykoz",
      "kadikoy"
    ],
    "localContext": "Üsküdar'da sahil dükkânları, tarihi çarşı alanları, klinikler, site girişleri ve mahalle esnafı kepenk sistemlerini farklı şartlarda kullanır.",
    "businessProfile": "Merkez ve Kuzguncuk'ta butik ve yeme-içme işletmeleri, Altunizade'de ofis/klinikler, Bulgurlu ve Kısıklı'da mahalle dükkânları öne çıkar.",
    "accessNote": "Sahil ve merkez bölgesinde trafik ve park koşulları servis zamanlamasında dikkate alınır.",
    "serviceNeed": "Üsküdar kepenk servisinde nem kontrolü, vitrin hizası, kumanda sistemi, motor sesi ve manuel açma sistemi birlikte kontrol edilir.",
    "repairNeed": "Sık arızalar ray sertleşmesi, motor sesi, kumanda çekmemesi ve kilit mekanizması sertleşmesi.",
    "cta": "Üsküdar kepenk servisi için mahalle ve kepenk konumunu bildirerek servis isteyin.",
    "faults": [
      "ray sertleşmesi",
      "motor sesi",
      "kumanda çekmemesi",
      "kilit sertleşmesi"
    ]
  },
  {
    "slug": "zeytinburnu",
    "name": "Zeytinburnu",
    "region": "Avrupa Yakası",
    "priority": 1,
    "neighborhoods": [
      "Beştelsiz",
      "Cevizlibağ",
      "Kazlıçeşme",
      "Merkezefendi",
      "Seyitnizam",
      "Sümer",
      "Veliefendi"
    ],
    "nearby": [
      "bakirkoy",
      "fatih",
      "gungoren"
    ],
    "localContext": "Zeytinburnu'nda tekstil, deri, sanayi, cadde dükkânları ve sahil çevresi işletmeleri kepenk sistemlerini yoğun ve farklı koşullarda kullanır.",
    "businessProfile": "Merkezefendi ve Seyitnizam'da atölye ve tekstil, Cevizlibağ ve Veliefendi'de cadde ticareti, Kazlıçeşme tarafında sahil-işletme karışması öne çıkar.",
    "accessNote": "Yoğun ticari alanlarda servis için kepengin açık/kapalı kalma durumu ve yükleme saatleri önemlidir.",
    "serviceNeed": "Zeytinburnu kepenk servisinde motor torku, ray aşınması, zincir sistemi, alıcı kart ve kilit güvenliği birlikte kontrol edilir.",
    "repairNeed": "Sık arızalar raydan çıkma, motorun zor kalkması, alıcı kart arızası ve kepenk perdesinde darbe izidir.",
    "cta": "Zeytinburnu kepenk tamiri için mahalle, kepenk turu ve arıza fotoğrafını paylaşabilirsiniz.",
    "faults": [
      "raydan çıkma",
      "motorun zor kalkması",
      "alıcı kart arızası",
      "perde darbesi"
    ]
  }
];

export default districtProfiles;
